import React from 'react';

import { Box } from '@betterment/style-closet-react';

import Loader from './Loader';

const FullPageLoader: React.FC<React.PropsWithChildren<{ isLoading?: boolean }>> = ({ isLoading = true }) => (
  <Box display="flex" height="100vh">
    <Loader isLoading={isLoading} />
  </Box>
);

export default FullPageLoader;
